/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  if (window.location.origin + window.location.pathname === 'https://flexfits.com/pages/en-CA') {
    const locale = new Intl.Locale(navigator.language);
    switch (locale.baseName) {
      case 'fr-CA':
        window.location.replace("https://flexfits.com/pages/fr-CA");
        break;
    }
  }

  // Add an event listener to pre-select the subscription option on PDPs.
  document.addEventListener('DOMContentLoaded', function() {
    // Add an event listener to pre-select the collection on Collection tabs.
    if (window.location.pathname.includes('/collections/')) {
      const options = ["best-sellers", "period-care", "bundles", "wellness-supplements", "merch", "extras"];
      const siteURL = location.href.split("?")[0];
      const section = siteURL.split("/").at(-1);
      let sectionIndex = options.indexOf(section);
      let tab = document.querySelector(`[data-tabs-link="${sectionIndex}"]`);
      if(tab) {
        tab.click()
      }
    }

    if (window.location.href === 'https://flexfits.com/') {
      let clickableImages = document.querySelectorAll('[id^="BrickBlock--"], [id^="SectionBannerImage--template"]');
      clickableImages.forEach((element) => {
        element.addEventListener("click", function () {
          let button = element.getElementsByClassName("main-buttons__item")[0].children[0];
          if (button) {
            button.click();
          }
        });
      });
    }
  });
  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
